const greekLetters = [
  { name: 'Alfa', abbr: 'A', greek: 'Α', latin: ['A'], value: 1, show: true },
  { name: 'Alfa', abbr: 'a', greek: 'α', latin: ['a'], value: 1 },

  { name: 'Beta', abbr: 'B', greek: 'Β', latin: ['B'], value: 2, show: true },
  { name: 'Beta', abbr: 'b', greek: 'β', latin: ['b'], value: 2 },

  { name: 'Gamma', abbr: 'G', greek: 'Γ', latin: ['G'], value: 3, show: true },
  { name: 'Gamma', abbr: 'g', greek: 'γ', latin: ['g'], value: 3 },

  { name: 'Delta', abbr: 'D', greek: 'Δ', latin: ['D'], value: 4, show: true },
  { name: 'Delta', abbr: 'd', greek: 'δ', latin: ['d'], value: 4 },

  { name: 'Epsilon', abbr: 'E', greek: 'Ε', latin: ['E'], value: 5, show: true },
  { name: 'Epsilon', abbr: 'e', greek: 'ε', latin: ['e'], value: 5 },

  { name: 'Digamma', abbr: 'V', greek: 'Ϝ', latin: ['V'], value: 6, show: true },
  { name: 'Digamma', abbr: 'v', greek: 'ϝ', latin: ['v'], value: 6 },

  { name: 'Stigma', abbr: '\\(ST\\)', greek: 'Ϛ', latin: ['\\(ST\\)'], value: 6, show: true },
  { name: 'Stigma', abbr: '\\(st\\)', greek: 'ϛ', latin: ['\\(st\\)'], value: 6 },

  { name: 'Zeta', abbr: 'Z', greek: 'Ζ', latin: ['Z'], value: 7, show: true },
  { name: 'Zeta', abbr: 'z', greek: 'ζ', latin: ['z'], value: 7 },

  { name: 'Eta', abbr: 'Ê', greek: 'Η', latin: ['H', 'Ê', 'Ẽ'], value: 8, show: true },
  { name: 'Eta', abbr: 'ê', greek: 'η', latin: ['h', 'ê', 'ẽ'], value: 8 },

  { name: 'Theta', abbr: 'T-', greek: 'Θ', latin: ['T-'], value: 9, show: true },
  { name: 'Theta', abbr: 't-', greek: 'θ', latin: ['t-'], value: 9 },

  { name: 'Iota', abbr: 'I', greek: 'Ι', latin: ['I'], value: 10, show: true },
  { name: 'Iota', abbr: 'i', greek: 'ι', latin: ['i'], value: 10 },

  { name: 'Kappa', abbr: 'K', greek: 'Κ', latin: ['K'], value: 20, show: true },
  { name: 'Kappa', abbr: 'k', greek: 'κ', latin: ['k'], value: 20 },

  { name: 'Lambda', abbr: 'L', greek: 'Λ', latin: ['L'], value: 30, show: true },
  { name: 'Lambda', abbr: 'l', greek: 'λ', latin: ['l'], value: 30 },

  { name: 'Mu', abbr: 'M', greek: 'Μ', latin: ['M'], value: 40, show: true },
  { name: 'Mu', abbr: 'm', greek: 'μ', latin: ['m'], value: 40 },

  { name: 'Nu', abbr: 'N', greek: 'Ν', latin: ['N'], value: 50, show: true },
  { name: 'Nu', abbr: 'n', greek: 'ν', latin: ['n'], value: 50 },

  { name: 'Si', abbr: 'Ś', greek: 'Ξ', latin: ['Ś'], value: 60, show: true },
  { name: 'Si', abbr: 'ś', greek: 'ξ', latin: ['ś'], value: 60 },

  { name: 'Ômicron', abbr: 'O', greek: 'Ο', latin: ['O'], value: 70, show: true },
  { name: 'Ômicron', abbr: 'o', greek: 'ο', latin: ['o'], value: 70 },

  { name: 'Pi', abbr: 'P', greek: 'Π', latin: ['P'], value: 80, show: true },
  { name: 'Pi', abbr: 'p', greek: 'π', latin: ['p'], value: 80 },

  { name: 'Qoppa', abbr: 'Q', greek: 'Ϙ', latin: ['Q'], value: 90, show: true },
  { name: 'Qoppa', abbr: 'q', greek: 'ϙ', latin: ['q'], value: 90 },

  { name: 'Ro', abbr: 'R', greek: 'Ρ', latin: ['R'], value: 100, show: true },
  { name: 'Ro', abbr: 'r', greek: 'ρ', latin: ['r'], value: 100 },

  { name: 'Sigma', abbr: 'C', greek: 'Ϲ', latin: ['C'], value: 200, show: true },
  { name: 'Sigma', abbr: 'c', greek: 'ς', latin: ['c'], value: 200 },

  { name: 'Sigma', abbr: 'S', greek: 'Σ', latin: ['S'], value: 200, show: true },
  { name: 'Sigma', abbr: 's', greek: 'σ', latin: ['s'], value: 200 },

  { name: 'Tau', abbr: 'T', greek: 'Τ', latin: ['T'], value: 300, show: true },
  { name: 'Tau', abbr: 't', greek: 'τ', latin: ['t'], value: 300 },

  { name: 'Upsilon', abbr: 'Y', greek: 'Υ', latin: ['Y'], value: 400, show: true },
  { name: 'Upsilon', abbr: 'y', greek: 'υ', latin: ['y'], value: 400 },

  { name: 'Phi', abbr: 'F', greek: 'Φ', latin: ['F'], value: 500, show: true },
  { name: 'Phi', abbr: 'f', greek: 'φ', latin: ['f'], value: 500 },

  { name: 'Chi', abbr: 'X', greek: 'Χ', latin: ['X'], value: 600, show: true },
  { name: 'Chi', abbr: 'x', greek: 'χ', latin: ['x'], value: 600 },

  { name: 'Psi', abbr: 'Ç', greek: 'Ψ', latin: ['Ç'], value: 700, show: true },
  { name: 'Psi', abbr: 'ç', greek: 'ψ', latin: ['ç'], value: 700 },

  { name: 'Ômega', abbr: 'Ô', greek: 'Ω', latin: ['Ô', 'Õ', 'W'], value: 800, show: true },
  { name: 'Ômega', abbr: 'ô', greek: 'ω', latin: ['ô', 'õ', 'w'], value: 800 },

  { name: 'Sampi', abbr: 'J', greek: 'Ϡ', latin: ['J'], value: 900, show: true },
  { name: 'Sampi', abbr: 'j', greek: 'ϡ', latin: ['j'], value: 900 }
]

const greekLettersConversionOrder = []

greekLetters.forEach((item) => {
  item.latin.forEach((latin) => {
    greekLettersConversionOrder.push({
      from: latin,
      to: item.abbr
    })
  })
})

let greekLettersMap = {}

for (let order of greekLettersConversionOrder) {
  for (let letter of greekLetters) {
    if (letter.abbr === order.to) {
      greekLettersMap[order.from] = letter
    }
  }
}

const transliterationToGreek = function (transliteration) {
  let greek = transliteration

  for (let order of greekLettersConversionOrder) {
    greek = greek.replace(
      new RegExp(order.from, 'g'),
      greekLettersMap[order.to].greek
    )
  }

  return greek
}

const gematria = function (greek) {
  let word = greek
  let total = 0

  for (let letter of greekLetters) {
    while (word.indexOf(letter.greek) > -1) {
      total += letter.value
      word = word.replace(letter.greek, '')
    }
  }

  return total
}

const gematriaEquation = function (greek, options = {}) {
  let words = greek.toLowerCase()

  if (options.sigmaTauBecomesDigamma) {
    words = words.replace(/στ/g, 'ϛ')
  }

  words = words.split(' ')

  const wordsGematria = []
  let total = 0
  let gematriaEquationValue = ''

  for (let word of words) {
    let wordGematria = gematria(word)
    total += wordGematria
    wordsGematria.push(wordGematria)
  }

  gematriaEquationValue = wordsGematria.join('+')

  if (total === 0) {
    gematriaEquationValue = ''
  }

  if (wordsGematria.length > 1) {
    gematriaEquationValue = gematriaEquationValue + '=' + total
  }

  return gematriaEquationValue
}

export { greekLetters, gematria, gematriaEquation, transliterationToGreek }



// WEBPACK FOOTER //
// ./src/greek.js